import { Button, Div, MultilineInput, Span } from '@tblabs/truffle';
import { Row } from '../General/Row';
import { Translations } from '../../Translations/Translations';
import { ReceiverLogic } from '../../Logic/ReceiverLogic';


export class OcrBox extends Div
{
    constructor(_lang: Translations, _logic: ReceiverLogic)
    {
        super("ocr");

        this.Append(
            new Row().TextAlignLeft().Append(
                new Span(_lang.TextFromPicture).Class("title"),
                new Button("×").OnClick(() => _logic.ShowOcrBox.False()).Class("close-ocr-button")
            ),
            new MultilineInput(_logic.OcrText).Rows(20).Class("ocr-text-area")
        );

        this.Visible(_logic.ShowOcrBox);
    }
}
